//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import isEmpty from 'lodash/isEmpty';
export default {
  props: {
    side: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  computed: {
    selectorUsed: function selectorUsed() {
      return this.$store.state.elements[this.side][this.index].tag.tagSelectorUsed;
    },
    empty: function empty() {
      // True if no tag if pattern is empty and no tag was selected in the friendly selector
      return isEmpty(this.value) && isEmpty(this.$store.state.elements[this.side][this.index].tag.pattern);
    },
    value: {
      get: function get() {
        return this.$store.getters['elements/at'](this.side, this.index).tag.value;
      },
      set: function set(value) {
        this.$store.commit('elements/setFieldValue', {
          side: this.side,
          index: this.index,
          field: 'tag',
          value: value
        });
      }
    },
    selectedTagsList: function selectedTagsList() {
      if (this.empty) {
        return '';
      } else {
        return this.value.sort().join(', ');
      }
    }
  },
  methods: {
    // Friendly selector selection has to be confirmed pressing ok button in the modal.
    // That is why the tag value is managed in NcsTagSelector instead of NcsFriendlySelector.
    // In NcsPatternSelector tag value is set directly since it cannot be cancelled.
    cleanFriendlySelector: function cleanFriendlySelector() {
      this.$refs.friendlySelector.reset();
    },
    confirmFriendlySelector: function confirmFriendlySelector(closeModal) {
      var availableOptions = this.$refs.friendlySelector.availableOptions; // If all options are selected, remove tag filter

      if (availableOptions.length === this.$ncsConfig.tags.matrix.length) {
        this.value = null;
      } else {
        // Parts with a space are removed, they are a workaround to be able to select an option that doesn't add a part.
        var buildTag = function buildTag(t) {
          return t.filter(function (e) {
            return e !== ' ';
          }).join('');
        };

        this.value = availableOptions.map(buildTag);
      }

      this.$store.commit('elements/setFieldAttr', {
        side: this.side,
        index: this.index,
        field: 'tag',
        attr: 'tagSelectorUsed',
        value: 'friendly'
      });
      closeModal();
    }
  },
  watch: {
    selectorUsed: function selectorUsed(value) {
      if (value === 'friendly') {
        this.$refs.patternSelector.reset();
      } else if (value === 'friendly') {
        this.$refs.friendlySelector.reset();
      }
    }
  }
};